import { createFileRoute } from "@tanstack/react-router";
import { SignInFinished } from "../components/connections/sign-in-finished";

// Outside `_authenticated`: the browser a desktop sign-in ends in may have no Abacor session.
export const Route = createFileRoute("/connections/finished")({
  component: SignInFinished,
});
